<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M3210.31 2240.17l-2822.3 0 0 -1058.35 896.08 0 -366.87 499.14 285.73 206.4 419.81 -571.54 176.4 -239.87 176.4 239.87 419.81 571.54 285.73 -206.4 -366.87 -499.14 896.08 0 0 1058.35zm0 881.94l-2822.3 0 0 -352.8 2822.3 0 0 352.8zm-1940.36 -2645.9c97.47,0 176.47,79 176.47,176.4 0,97.4 -79,176.4 -176.4,176.4 -97.4,0 -176.4,-79 -176.4,-176.4 0,-97.4 79,-176.4 176.4,-176.4l-0.07 0zm1058.42 0c97.4,0 176.4,79 176.4,176.4 0,97.4 -79,176.4 -176.4,176.4 -97.4,0 -176.41,-79 -176.41,-176.4 0,-97.4 79.01,-176.4 176.41,-176.4l0 0zm881.94 352.8l-384.54 0c19.4,-54.66 31.74,-114.66 31.74,-176.4 0.06,-292.2 -236.94,-529.2 -529.14,-529.2 -185.27,0.06 -345.74,95.26 -441.01,238.2l-88.2 114.6 -88.2 -116.4c-95.27,-141.14 -255.74,-236.34 -441.01,-236.34 -292.13,-0.06 -529.14,236.94 -529.14,529.14 0,61.74 12.34,121.74 31.74,176.4l-384.54 0c-195.8,0 -352.74,157.01 -352.74,352.81l0 1940.29c0,195.8 156.94,352.8 352.74,352.8l2822.3 0c195.8,0 352.74,-157 352.74,-352.8l0 -1940.29c0,-195.8 -156.94,-352.81 -352.74,-352.81z"/>
  </g>
 </g>
</svg>
